import { render, staticRenderFns } from "./wechatAuthorization.vue?vue&type=template&id=22ba14e4&scoped=true&"
import script from "./wechatAuthorization.vue?vue&type=script&lang=js&"
export * from "./wechatAuthorization.vue?vue&type=script&lang=js&"
import style0 from "./wechatAuthorization.vue?vue&type=style&index=0&id=22ba14e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ba14e4",
  null
  
)

export default component.exports